import { useState } from "react"

export const registerForm = async (name, projectIncludes, roomDefinitions, rooms, projectHas, pavements, clientInfos, _id, completed) => {
  const response = await fetch(`https://6uc1i3mmsh.execute-api.us-east-1.amazonaws.com/prod/cartesian/registerForm`, {
    method: "POST",
    body: JSON.stringify({
      name,
      projRoomFull: projectIncludes,
      roomDefinitions,
      rooms,
      projectHas,
      pavements,
      clientInfos,
      _id,
      completed
    }),
  }).then(res => {
    return res.json()
  })

  return response
}

export const updateForm = async (_id, clientInfos, completed, email) => {
  const response = await fetch(`https://6uc1i3mmsh.execute-api.us-east-1.amazonaws.com/prod/cartesian/registerForm`, {
    method: "POST",
    body: JSON.stringify({
      clientInfos,
      _id,
      completed,
      email
    }),
  })

  return response
}

export const deleteForm = async (id) => {
  const response = await fetch(`https://6uc1i3mmsh.execute-api.us-east-1.amazonaws.com/prod/cartesian/getForm?id=${id}&dlt=true`, {
    method: "GET"
  }).then(res => {
    return res.json()
  })

  return response
}

export const getInfo = async (id) => {
  const response = await fetch(`https://6uc1i3mmsh.execute-api.us-east-1.amazonaws.com/prod/cartesian/getForm?id=${id}`, {
    method: "GET"
  }).then(res => {
    return res.json()
  })

  return response
}

export const translateRoom = (room) => {
  const translations = {
    guardrail: "Guarda-corpo",
    stairs: "Escada",
    floors: "Pisos",
    hidrWalls: "Paredes Hidráulicas",
    pools: "Piscinas",
    privAreas: "Áreas Privativas"
  }
  return translations[room] || room
}

export const defaultCardSelection = (i, check, click) => {
  return <div key={i} className={`project-includes-card ${check ? "selected" : ""}`} onClick={() => click(i)}>
    <label>{i}</label>
  </div>
}

export const singleAnswerForm = (label, options, idx, field, fullDesc, toCheckDef, group, handleChanges, finished) => {
  const toCheckSelected = group[field]
  const extraField = field + "Extra"
  const colorField = field + "Color"
  const paintTypeField = field + "PaintType"
  const valueRangeField = field + "ValueRange"
  const obsField = field + "Obs"
  return <div className="question-container">
    <p className="margin-tier-1">{label}</p>
    <div className="project-includes-container margin-tier-2 margin-bottom-8">
      {options.map(i => {
        if (i?.toLowerCase() === "seguir descrição do projeto" && !fullDesc.includes(toCheckDef)) {
          return null
        }
        return defaultCardSelection(i, toCheckSelected === i, () => handleChanges(i, idx, field))
      })}
    </div>
    {toCheckSelected === "Outro" && <div className="margin-top-4 margin-tier-1">
      <input className="extra-field" disabled={finished} placeholder="Outro" type="text" value={group[extraField]} onChange={(e) => handleChanges(e.target.value, idx, extraField)} />
    </div>}
    {(toCheckSelected?.toLowerCase() === "pintura" || toCheckSelected?.toLowerCase() === "textura branca + pintura" || toCheckSelected?.toLowerCase() === "textura pigmentada") && <div className="margin-top-4 margin-tier-1">
      <input className="extra-field" disabled={finished} placeholder="Cor/código da pintura/textura" value={group[colorField]} type="text" onChange={(e) => handleChanges(e.target.value, idx, colorField)} />
    </div>}
    {(toCheckSelected?.toLowerCase() === "pintura") && <div className="margin-top-4 margin-tier-1">
      <input className="extra-field" disabled={finished} placeholder="Tipo de pintura" type="text" value={group[paintTypeField]} onChange={(e) => handleChanges(e.target.value, idx, paintTypeField)} />
    </div>}
    {(toCheckSelected?.toLowerCase() === "peça cerâmica" || toCheckSelected?.toLowerCase() === "pastilha" || toCheckSelected?.toLowerCase() === "porcelanato") && <div className="margin-top-4 margin-tier-1">
      <input className="extra-field" placeholder="Faixa de valor" type="text" value={group[valueRangeField]} onChange={(e) => handleChanges(e.target.value, idx, valueRangeField)} />
    </div>}
    <p className="margin-tier-1">Observações</p>
    <input className="extra-field  margin-bottom-8" disabled={finished} placeholder="Observações" value={group[obsField]} type="text" onChange={(e) => handleChanges(e.target.value, idx, obsField)} />
  </div>
}

export const multipleAnswerForm = (label, options, idx, field, group, handleMultiple, fullDesc, toCheckDef, handleChanges, finished) => {
  const checkIfSelected = group[field]
  const extraField = field + "Extra"
  const obsField = field + "Obs"

  return <div className="question-container">
    <p className="margin-tier-1">{label}</p>
    <div className="margin-bottom-16">
      <div className="project-includes-container margin-tier-2 margin-bottom-8">
        {options.map(j => {
          if (j?.toLowerCase() === "seguir descrição do projeto" && !fullDesc.includes(toCheckDef)) {
            return null
          }
          return defaultCardSelection(j, checkIfSelected.map(i => i.type).includes(j), () => handleMultiple(idx, field, j))
        })}
      </div>
    </div>
    {checkIfSelected.map(i => i.type).includes("Outro") &&
      <div className="margin-tier-2 margin-bottom-8">
        <label>Outro: </label> <input type="text" disabled={finished} value={group[extraField]} onChange={(e) => handleChanges(e.target.value, idx, extraField)} />
      </div>
    }
    <p className="margin-tier-1">Observações</p>
    <input className="extra-field" placeholder="Observações" disabled={finished} value={group[obsField]} type="text" onChange={(e) => handleChanges(e.target.value, idx, obsField)} />
  </div>
}

export const GroupHeader = ({ idx, rooms, handleToggle, active, groups, setGroups, remaining }) => {
  const [editing, setEditing] = useState('')

  const resetGroup = () => {
    const newGroups = [...groups];
    newGroups.splice(idx, 1);
    setGroups(newGroups);
    // setCurrentGroup([]);
  }

  const editGroup = (e) => {
    const toIdx = parseInt(e.target.value);
    const currentGroup = groups[idx];
    const targetGroup = groups[toIdx];
    const updatedCurrentRooms = currentGroup.rooms.filter(room => room !== editing);
    const updatedCurrentGroup = { ...currentGroup, rooms: updatedCurrentRooms };

    if (toIdx !== -1) {
      const updatedTargetRooms = [...targetGroup.rooms, editing];
      const updatedTargetGroup = { ...targetGroup, rooms: updatedTargetRooms };
      const newGroups = groups.map((group, index) => {
        if (index === idx) return updatedCurrentGroup;
        if (index === toIdx) return updatedTargetGroup;
        return group;
      });
      setGroups(newGroups);

    } else {
      const newGroups = groups.map((group, index) => {
        if (index === idx) return updatedCurrentGroup;
        return group;
      });
      setGroups(newGroups);
    }

    setEditing('')
  }

  return <>
    <div className="flex" style={{ alignItems: "center" }}>
      <button
        style={{ width: "35px" }}
        className={`accordion-toggle ${active ? 'active' : ''}`}
        onClick={() => handleToggle(idx)}
      />
      <label className="group-header margin-tier-1">Grupo {idx + 1}</label>
    </div>

    <button className="edit-group-button" onClick={() => resetGroup(idx)}>Deletar grupo</button>
    <br />
    {rooms.map(i => {
      return <p style={{ display: "inline-block", cursor: "pointer" }} key={i} onClick={() => setEditing(editing === i ? '' : i)} className="small-reminder margin-tier-2">{i}</p>
    })}
    {editing !== '' && <div>
      <p>Mudar {editing} pro grupo:</p>
      <select className="edit-group-target-selector" style={{ maxWidth: '350px' }} defaultValue={""} onChange={editGroup}>
        <option value="" disabled>Escolha uma opção</option>
        {groups.map((i, _idx) => {
          if (_idx === idx) return null;
          return <option key={_idx} value={_idx} onClick={() => handleEdit(_idx)}>Grupo {_idx + 1}</option>
        })}
        <option value={-1}>Remover do grupo</option>
      </select>
    </div>}

    <div>
      <p>Adicionar um ambiente ao grupo:</p>
      <select style={{ maxWidth: '350px' }} className="edit-group-target-selector" defaultValue={""} onChange={(e) => {
        const newRoom = e.target.value;
        if (!rooms.includes(newRoom)) {
          const newGroups = [...groups];
          newGroups[idx].rooms.push(newRoom);
          setGroups(newGroups);
        }
      }}>
        <option value="" disabled>Escolha um ambiente</option>
        {remaining?.map((room) => {
          if (rooms.includes(room)) return null;
          return <option key={room} value={room}>{room}</option>
        })}
      </select>
    </div>
  </>
}

export const selectHeader = (all, bulk) => {
  return <div className="project-includes-container margin-tier-2 margin-bottom-8 select-all-container">
    <div className={`project-includes-card`} onClick={all}>
      <label>Selecionar Todos</label>
    </div>
    <div className={`project-includes-card`} onClick={() => bulk(true)}>
      <label>Selecionar Áreas Privativas</label>
    </div>
    <div className={`project-includes-card`} onClick={() => bulk(false)}>
      <label>Selecionar Áreas Comuns</label>
    </div>
  </ div>
}

export const mainHeader = (label, groups, resetAll, toggle, setToggle) => {
  return <div className="header-container">
    <div className="flex" style={{ alignItems: "center" }}>
      <button
        style={{ width: "35px" }}
        className={`accordion-toggle ${toggle ? "active" : ""}`}
        onClick={() => setToggle(!toggle)}
      />
      <h2 className="main-header">{label}</h2>
    </div>

    {toggle && <>
      <p className="small-reminder">Selecione os ambientes que vão compartilhas as mesmas configurações</p>
      {groups.length > 0 && <button onClick={resetAll} className="reset-all-button">Resetar grupos</button>}
    </>}
  </div>
}

const checkRemaining = (arr, groups) => {
  const remaining = arr?.filter(i => !groups.flatMap(group => group.rooms).includes(i));
  return remaining;
}

export const groupSelector = (formatPav, groups, currentGroup, handleGroup, finishGroup, rooms) => {
  return <>
    <div className="group-questions-container">
      {formatPav.map(i => {
        if (checkRemaining(i.rooms, groups).length === 0) return;
        return <div className="question-container">
          <label>{i.pavement}</label>
          <div className="project-includes-container margin-tier-2 margin-bottom-8">
            {checkRemaining(i.rooms, groups).map(j => {
              return <div key={j} className={`project-includes-card ${currentGroup.includes(j) ? "selected" : ""}`} onClick={() => handleGroup(j)}>
                <label>{j}</label>
              </div>
            })}
          </div>
        </div>
      })}
    </div>
    {checkRemaining(rooms, groups).length > 0 && <button className="button button-secondary margin-tier-2 margin-top-16" disabled={currentGroup.length === 0} onClick={finishGroup}> Finalizar Grupo</button>}
  </>
}

export const handleMultiple = (finished, groups, idx, field, type, fill, setGroups) => {
  if (finished) return;
  const newGroups = [...groups];
  const current = newGroups[idx][field];
  if (type === 'Nenhum') {
    newGroups[idx][field] = [{ type: 'Nenhum', fill }];
  } else {
    let filtered = current.filter(i => i.type !== 'Nenhum');
    if (filtered.map(i => i.type).includes(type)) {
      filtered = filtered.filter(i => i.type !== type);
    } else {
      filtered = [...filtered, fill];
    }
    newGroups[idx][field] = filtered;
  }
  setGroups(newGroups);
}